import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { FieldType } from '@sla-ng/ui-material';
import { map } from 'rxjs/operators';
import { ICostAccounting } from '../../models/cost-accounting.model';
import { CostAccountingStateEnum } from '../../models/enum/cost-accounting-state.enum';
import { ICostUnitCostLayout } from '../../models/layout/cost-unit-cost-layout.model';
import { CostAccountingFacade } from '../facades/cost-accounting/cost-accounting.facade';
import { SharedDataFacade } from '../facades/master-data/shared-data.facade';

@Injectable({
    providedIn: 'root',
})
export class CostUnitCostLayoutService {

    constructor(protected myCostAccountingFacade: CostAccountingFacade,
                protected mySharedDataFacade: SharedDataFacade,
                protected myTranslateService: TranslateService) {
    }

    public getCostUnitCostLayout(): ICostUnitCostLayout {
        return {
            costAccountingSelection: {
                type: FieldType.select,
                field: 'costAccounting',
                label: 'app.page.cost-unit-cost.costAccounting.label',
                selectData: {
                    // Only CostAccountings that are finished should be available for selection
                    options: this.myCostAccountingFacade.fetchCostAccountings()
                        .pipe(map((costAccountings: ICostAccounting[]) => {
                            return costAccountings.filter(cA => cA.state === CostAccountingStateEnum.COST_UNIT_ACCOUNTING);
                        })),
                    valueKey: 'id',
                    labelKeys: [ 'name' ],
                    displaySearch: true,
                },
            },
            costUnitSelection: {
                type: FieldType.select,
                field: 'costUnit',
                label: 'app.page.cost-unit-cost.costUnit.label',
                selectData: {
                    displaySearch: true,
                    labelKeys: [ 'articleNr', 'name' ],
                    options: this.mySharedDataFacade.fetchCostUnits(),
                    separator: ' - ',
                    valueKey: 'id',
                },
            },
            graphFilterSelection: [
                {
                    type: FieldType.select,
                    field: 'measureUnit',
                    label: 'app.page.cost-unit-cost.measure-unit.label',
                    withClearButton: true,
                    selectData: {
                        displaySearch: true,
                        labelKeys: [ 'name' ],
                        options: this.mySharedDataFacade.fetchMeasureUnits(),
                        valueKey: 'id',
                    },
                },
                {
                    type: FieldType.select,
                    field: 'costingLevel',
                    label: 'app.page.cost-unit-cost.costingLevel.label',
                    withClearButton: true,
                    selectData: {
                        displaySearch: true,
                        labelKeys: [ 'name' ],
                        options: this.mySharedDataFacade.fetchCostingLevels(),
                        valueKey: 'id',
                    },
                },

            ],
            chartConfig: {
                chartType: 'bar',
                legend: false,
                chartOptions: {
                    backgroundColor: '#100C46',
                    indexAxis: 'y',
                    scales: {
                        x: {
                            display: true,
                            title: {
                                display: true,
                                text: this.myTranslateService.instant('app.page.cost-unit-cost.cost.label'),
                            },
                        },
                    },
                    // Append €-sign to tooltip value
                    plugins: {
                        tooltip: {
                            callbacks: {
                                label(tooltipItem: { formattedValue: string }): string {
                                    return `${tooltipItem.formattedValue} €`;
                                },
                            },
                        },
                    },
                },
            },
        };
    }
}
